(window["webpackJsonp"] = window["webpackJsonp"] || []).push([["main"],{

/***/ "../../node_modules/moment/locale sync recursive ^\\.\\/.*$":
/*!***************************************************************************************!*\
  !*** /home/administrator/app/mobility-tv-v2/node_modules/moment/locale sync ^\.\/.*$ ***!
  \***************************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": "../../node_modules/moment/locale/af.js",
	"./af.js": "../../node_modules/moment/locale/af.js",
	"./ar": "../../node_modules/moment/locale/ar.js",
	"./ar-dz": "../../node_modules/moment/locale/ar-dz.js",
	"./ar-dz.js": "../../node_modules/moment/locale/ar-dz.js",
	"./ar-kw": "../../node_modules/moment/locale/ar-kw.js",
	"./ar-kw.js": "../../node_modules/moment/locale/ar-kw.js",
	"./ar-ly": "../../node_modules/moment/locale/ar-ly.js",
	"./ar-ly.js": "../../node_modules/moment/locale/ar-ly.js",
	"./ar-ma": "../../node_modules/moment/locale/ar-ma.js",
	"./ar-ma.js": "../../node_modules/moment/locale/ar-ma.js",
	"./ar-sa": "../../node_modules/moment/locale/ar-sa.js",
	"./ar-sa.js": "../../node_modules/moment/locale/ar-sa.js",
	"./ar-tn": "../../node_modules/moment/locale/ar-tn.js",
	"./ar-tn.js": "../../node_modules/moment/locale/ar-tn.js",
	"./ar.js": "../../node_modules/moment/locale/ar.js",
	"./az": "../../node_modules/moment/locale/az.js",
	"./az.js": "../../node_modules/moment/locale/az.js",
	"./be": "../../node_modules/moment/locale/be.js",
	"./be.js": "../../node_modules/moment/locale/be.js",
	"./bg": "../../node_modules/moment/locale/bg.js",
	"./bg.js": "../../node_modules/moment/locale/bg.js",
	"./bm": "../../node_modules/moment/locale/bm.js",
	"./bm.js": "../../node_modules/moment/locale/bm.js",
	"./bn": "../../node_modules/moment/locale/bn.js",
	"./bn.js": "../../node_modules/moment/locale/bn.js",
	"./bo": "../../node_modules/moment/locale/bo.js",
	"./bo.js": "../../node_modules/moment/locale/bo.js",
	"./br": "../../node_modules/moment/locale/br.js",
	"./br.js": "../../node_modules/moment/locale/br.js",
	"./bs": "../../node_modules/moment/locale/bs.js",
	"./bs.js": "../../node_modules/moment/locale/bs.js",
	"./ca": "../../node_modules/moment/locale/ca.js",
	"./ca.js": "../../node_modules/moment/locale/ca.js",
	"./cs": "../../node_modules/moment/locale/cs.js",
	"./cs.js": "../../node_modules/moment/locale/cs.js",
	"./cv": "../../node_modules/moment/locale/cv.js",
	"./cv.js": "../../node_modules/moment/locale/cv.js",
	"./cy": "../../node_modules/moment/locale/cy.js",
	"./cy.js": "../../node_modules/moment/locale/cy.js",
	"./da": "../../node_modules/moment/locale/da.js",
	"./da.js": "../../node_modules/moment/locale/da.js",
	"./de": "../../node_modules/moment/locale/de.js",
	"./de-at": "../../node_modules/moment/locale/de-at.js",
	"./de-at.js": "../../node_modules/moment/locale/de-at.js",
	"./de-ch": "../../node_modules/moment/locale/de-ch.js",
	"./de-ch.js": "../../node_modules/moment/locale/de-ch.js",
	"./de.js": "../../node_modules/moment/locale/de.js",
	"./dv": "../../node_modules/moment/locale/dv.js",
	"./dv.js": "../../node_modules/moment/locale/dv.js",
	"./el": "../../node_modules/moment/locale/el.js",
	"./el.js": "../../node_modules/moment/locale/el.js",
	"./en-SG": "../../node_modules/moment/locale/en-SG.js",
	"./en-SG.js": "../../node_modules/moment/locale/en-SG.js",
	"./en-au": "../../node_modules/moment/locale/en-au.js",
	"./en-au.js": "../../node_modules/moment/locale/en-au.js",
	"./en-ca": "../../node_modules/moment/locale/en-ca.js",
	"./en-ca.js": "../../node_modules/moment/locale/en-ca.js",
	"./en-gb": "../../node_modules/moment/locale/en-gb.js",
	"./en-gb.js": "../../node_modules/moment/locale/en-gb.js",
	"./en-ie": "../../node_modules/moment/locale/en-ie.js",
	"./en-ie.js": "../../node_modules/moment/locale/en-ie.js",
	"./en-il": "../../node_modules/moment/locale/en-il.js",
	"./en-il.js": "../../node_modules/moment/locale/en-il.js",
	"./en-nz": "../../node_modules/moment/locale/en-nz.js",
	"./en-nz.js": "../../node_modules/moment/locale/en-nz.js",
	"./eo": "../../node_modules/moment/locale/eo.js",
	"./eo.js": "../../node_modules/moment/locale/eo.js",
	"./es": "../../node_modules/moment/locale/es.js",
	"./es-do": "../../node_modules/moment/locale/es-do.js",
	"./es-do.js": "../../node_modules/moment/locale/es-do.js",
	"./es-us": "../../node_modules/moment/locale/es-us.js",
	"./es-us.js": "../../node_modules/moment/locale/es-us.js",
	"./es.js": "../../node_modules/moment/locale/es.js",
	"./et": "../../node_modules/moment/locale/et.js",
	"./et.js": "../../node_modules/moment/locale/et.js",
	"./eu": "../../node_modules/moment/locale/eu.js",
	"./eu.js": "../../node_modules/moment/locale/eu.js",
	"./fa": "../../node_modules/moment/locale/fa.js",
	"./fa.js": "../../node_modules/moment/locale/fa.js",
	"./fi": "../../node_modules/moment/locale/fi.js",
	"./fi.js": "../../node_modules/moment/locale/fi.js",
	"./fo": "../../node_modules/moment/locale/fo.js",
	"./fo.js": "../../node_modules/moment/locale/fo.js",
	"./fr": "../../node_modules/moment/locale/fr.js",
	"./fr-ca": "../../node_modules/moment/locale/fr-ca.js",
	"./fr-ca.js": "../../node_modules/moment/locale/fr-ca.js",
	"./fr-ch": "../../node_modules/moment/locale/fr-ch.js",
	"./fr-ch.js": "../../node_modules/moment/locale/fr-ch.js",
	"./fr.js": "../../node_modules/moment/locale/fr.js",
	"./fy": "../../node_modules/moment/locale/fy.js",
	"./fy.js": "../../node_modules/moment/locale/fy.js",
	"./ga": "../../node_modules/moment/locale/ga.js",
	"./ga.js": "../../node_modules/moment/locale/ga.js",
	"./gd": "../../node_modules/moment/locale/gd.js",
	"./gd.js": "../../node_modules/moment/locale/gd.js",
	"./gl": "../../node_modules/moment/locale/gl.js",
	"./gl.js": "../../node_modules/moment/locale/gl.js",
	"./gom-latn": "../../node_modules/moment/locale/gom-latn.js",
	"./gom-latn.js": "../../node_modules/moment/locale/gom-latn.js",
	"./gu": "../../node_modules/moment/locale/gu.js",
	"./gu.js": "../../node_modules/moment/locale/gu.js",
	"./he": "../../node_modules/moment/locale/he.js",
	"./he.js": "../../node_modules/moment/locale/he.js",
	"./hi": "../../node_modules/moment/locale/hi.js",
	"./hi.js": "../../node_modules/moment/locale/hi.js",
	"./hr": "../../node_modules/moment/locale/hr.js",
	"./hr.js": "../../node_modules/moment/locale/hr.js",
	"./hu": "../../node_modules/moment/locale/hu.js",
	"./hu.js": "../../node_modules/moment/locale/hu.js",
	"./hy-am": "../../node_modules/moment/locale/hy-am.js",
	"./hy-am.js": "../../node_modules/moment/locale/hy-am.js",
	"./id": "../../node_modules/moment/locale/id.js",
	"./id.js": "../../node_modules/moment/locale/id.js",
	"./is": "../../node_modules/moment/locale/is.js",
	"./is.js": "../../node_modules/moment/locale/is.js",
	"./it": "../../node_modules/moment/locale/it.js",
	"./it-ch": "../../node_modules/moment/locale/it-ch.js",
	"./it-ch.js": "../../node_modules/moment/locale/it-ch.js",
	"./it.js": "../../node_modules/moment/locale/it.js",
	"./ja": "../../node_modules/moment/locale/ja.js",
	"./ja.js": "../../node_modules/moment/locale/ja.js",
	"./jv": "../../node_modules/moment/locale/jv.js",
	"./jv.js": "../../node_modules/moment/locale/jv.js",
	"./ka": "../../node_modules/moment/locale/ka.js",
	"./ka.js": "../../node_modules/moment/locale/ka.js",
	"./kk": "../../node_modules/moment/locale/kk.js",
	"./kk.js": "../../node_modules/moment/locale/kk.js",
	"./km": "../../node_modules/moment/locale/km.js",
	"./km.js": "../../node_modules/moment/locale/km.js",
	"./kn": "../../node_modules/moment/locale/kn.js",
	"./kn.js": "../../node_modules/moment/locale/kn.js",
	"./ko": "../../node_modules/moment/locale/ko.js",
	"./ko.js": "../../node_modules/moment/locale/ko.js",
	"./ku": "../../node_modules/moment/locale/ku.js",
	"./ku.js": "../../node_modules/moment/locale/ku.js",
	"./ky": "../../node_modules/moment/locale/ky.js",
	"./ky.js": "../../node_modules/moment/locale/ky.js",
	"./lb": "../../node_modules/moment/locale/lb.js",
	"./lb.js": "../../node_modules/moment/locale/lb.js",
	"./lo": "../../node_modules/moment/locale/lo.js",
	"./lo.js": "../../node_modules/moment/locale/lo.js",
	"./lt": "../../node_modules/moment/locale/lt.js",
	"./lt.js": "../../node_modules/moment/locale/lt.js",
	"./lv": "../../node_modules/moment/locale/lv.js",
	"./lv.js": "../../node_modules/moment/locale/lv.js",
	"./me": "../../node_modules/moment/locale/me.js",
	"./me.js": "../../node_modules/moment/locale/me.js",
	"./mi": "../../node_modules/moment/locale/mi.js",
	"./mi.js": "../../node_modules/moment/locale/mi.js",
	"./mk": "../../node_modules/moment/locale/mk.js",
	"./mk.js": "../../node_modules/moment/locale/mk.js",
	"./ml": "../../node_modules/moment/locale/ml.js",
	"./ml.js": "../../node_modules/moment/locale/ml.js",
	"./mn": "../../node_modules/moment/locale/mn.js",
	"./mn.js": "../../node_modules/moment/locale/mn.js",
	"./mr": "../../node_modules/moment/locale/mr.js",
	"./mr.js": "../../node_modules/moment/locale/mr.js",
	"./ms": "../../node_modules/moment/locale/ms.js",
	"./ms-my": "../../node_modules/moment/locale/ms-my.js",
	"./ms-my.js": "../../node_modules/moment/locale/ms-my.js",
	"./ms.js": "../../node_modules/moment/locale/ms.js",
	"./mt": "../../node_modules/moment/locale/mt.js",
	"./mt.js": "../../node_modules/moment/locale/mt.js",
	"./my": "../../node_modules/moment/locale/my.js",
	"./my.js": "../../node_modules/moment/locale/my.js",
	"./nb": "../../node_modules/moment/locale/nb.js",
	"./nb.js": "../../node_modules/moment/locale/nb.js",
	"./ne": "../../node_modules/moment/locale/ne.js",
	"./ne.js": "../../node_modules/moment/locale/ne.js",
	"./nl": "../../node_modules/moment/locale/nl.js",
	"./nl-be": "../../node_modules/moment/locale/nl-be.js",
	"./nl-be.js": "../../node_modules/moment/locale/nl-be.js",
	"./nl.js": "../../node_modules/moment/locale/nl.js",
	"./nn": "../../node_modules/moment/locale/nn.js",
	"./nn.js": "../../node_modules/moment/locale/nn.js",
	"./pa-in": "../../node_modules/moment/locale/pa-in.js",
	"./pa-in.js": "../../node_modules/moment/locale/pa-in.js",
	"./pl": "../../node_modules/moment/locale/pl.js",
	"./pl.js": "../../node_modules/moment/locale/pl.js",
	"./pt": "../../node_modules/moment/locale/pt.js",
	"./pt-br": "../../node_modules/moment/locale/pt-br.js",
	"./pt-br.js": "../../node_modules/moment/locale/pt-br.js",
	"./pt.js": "../../node_modules/moment/locale/pt.js",
	"./ro": "../../node_modules/moment/locale/ro.js",
	"./ro.js": "../../node_modules/moment/locale/ro.js",
	"./ru": "../../node_modules/moment/locale/ru.js",
	"./ru.js": "../../node_modules/moment/locale/ru.js",
	"./sd": "../../node_modules/moment/locale/sd.js",
	"./sd.js": "../../node_modules/moment/locale/sd.js",
	"./se": "../../node_modules/moment/locale/se.js",
	"./se.js": "../../node_modules/moment/locale/se.js",
	"./si": "../../node_modules/moment/locale/si.js",
	"./si.js": "../../node_modules/moment/locale/si.js",
	"./sk": "../../node_modules/moment/locale/sk.js",
	"./sk.js": "../../node_modules/moment/locale/sk.js",
	"./sl": "../../node_modules/moment/locale/sl.js",
	"./sl.js": "../../node_modules/moment/locale/sl.js",
	"./sq": "../../node_modules/moment/locale/sq.js",
	"./sq.js": "../../node_modules/moment/locale/sq.js",
	"./sr": "../../node_modules/moment/locale/sr.js",
	"./sr-cyrl": "../../node_modules/moment/locale/sr-cyrl.js",
	"./sr-cyrl.js": "../../node_modules/moment/locale/sr-cyrl.js",
	"./sr.js": "../../node_modules/moment/locale/sr.js",
	"./ss": "../../node_modules/moment/locale/ss.js",
	"./ss.js": "../../node_modules/moment/locale/ss.js",
	"./sv": "../../node_modules/moment/locale/sv.js",
	"./sv.js": "../../node_modules/moment/locale/sv.js",
	"./sw": "../../node_modules/moment/locale/sw.js",
	"./sw.js": "../../node_modules/moment/locale/sw.js",
	"./ta": "../../node_modules/moment/locale/ta.js",
	"./ta.js": "../../node_modules/moment/locale/ta.js",
	"./te": "../../node_modules/moment/locale/te.js",
	"./te.js": "../../node_modules/moment/locale/te.js",
	"./tet": "../../node_modules/moment/locale/tet.js",
	"./tet.js": "../../node_modules/moment/locale/tet.js",
	"./tg": "../../node_modules/moment/locale/tg.js",
	"./tg.js": "../../node_modules/moment/locale/tg.js",
	"./th": "../../node_modules/moment/locale/th.js",
	"./th.js": "../../node_modules/moment/locale/th.js",
	"./tl-ph": "../../node_modules/moment/locale/tl-ph.js",
	"./tl-ph.js": "../../node_modules/moment/locale/tl-ph.js",
	"./tlh": "../../node_modules/moment/locale/tlh.js",
	"./tlh.js": "../../node_modules/moment/locale/tlh.js",
	"./tr": "../../node_modules/moment/locale/tr.js",
	"./tr.js": "../../node_modules/moment/locale/tr.js",
	"./tzl": "../../node_modules/moment/locale/tzl.js",
	"./tzl.js": "../../node_modules/moment/locale/tzl.js",
	"./tzm": "../../node_modules/moment/locale/tzm.js",
	"./tzm-latn": "../../node_modules/moment/locale/tzm-latn.js",
	"./tzm-latn.js": "../../node_modules/moment/locale/tzm-latn.js",
	"./tzm.js": "../../node_modules/moment/locale/tzm.js",
	"./ug-cn": "../../node_modules/moment/locale/ug-cn.js",
	"./ug-cn.js": "../../node_modules/moment/locale/ug-cn.js",
	"./uk": "../../node_modules/moment/locale/uk.js",
	"./uk.js": "../../node_modules/moment/locale/uk.js",
	"./ur": "../../node_modules/moment/locale/ur.js",
	"./ur.js": "../../node_modules/moment/locale/ur.js",
	"./uz": "../../node_modules/moment/locale/uz.js",
	"./uz-latn": "../../node_modules/moment/locale/uz-latn.js",
	"./uz-latn.js": "../../node_modules/moment/locale/uz-latn.js",
	"./uz.js": "../../node_modules/moment/locale/uz.js",
	"./vi": "../../node_modules/moment/locale/vi.js",
	"./vi.js": "../../node_modules/moment/locale/vi.js",
	"./x-pseudo": "../../node_modules/moment/locale/x-pseudo.js",
	"./x-pseudo.js": "../../node_modules/moment/locale/x-pseudo.js",
	"./yo": "../../node_modules/moment/locale/yo.js",
	"./yo.js": "../../node_modules/moment/locale/yo.js",
	"./zh-cn": "../../node_modules/moment/locale/zh-cn.js",
	"./zh-cn.js": "../../node_modules/moment/locale/zh-cn.js",
	"./zh-hk": "../../node_modules/moment/locale/zh-hk.js",
	"./zh-hk.js": "../../node_modules/moment/locale/zh-hk.js",
	"./zh-tw": "../../node_modules/moment/locale/zh-tw.js",
	"./zh-tw.js": "../../node_modules/moment/locale/zh-tw.js"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "../../node_modules/moment/locale sync recursive ^\\.\\/.*$";

/***/ }),

/***/ "../../node_modules/raw-loader/dist/cjs.js!./src/app/app.component.html":
/*!***************************************************************************************************************!*\
  !*** /home/administrator/app/mobility-tv-v2/node_modules/raw-loader/dist/cjs.js!./src/app/app.component.html ***!
  \***************************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<div class=\"container-fluid wrapper pl-4 pr-4\" style=\"overflow: auto;\" *ngIf=\"!errorMessage; else showErrorMessage\">\n  <div class=\"d-flex justify-content-center\" *ngIf=\"results.length === 0\">\n    <div class=\"spinner-border text-light\" style=\"width: 3rem; height: 3rem;\" role=\"status\">\n      <span class=\"sr-only\">Loading...</span>\n    </div>\n  </div>\n  <mobility-tv-display *ngIf=\"results.length > 0\" [results]=\"results\"></mobility-tv-display>\n</div>\n<ng-template #showErrorMessage>\n  <div class=\"alert alert-danger p-5 text-center\">\n    <span style=\"font-size: 3.5vw;\"><strong *ngIf=\"errorCode\">({{ errorCode }})</strong> {{ errorMessage }}</span>\n  </div>\n</ng-template>\n");

/***/ }),

/***/ "../../node_modules/raw-loader/dist/cjs.js!./src/app/display/display.component.html":
/*!***************************************************************************************************************************!*\
  !*** /home/administrator/app/mobility-tv-v2/node_modules/raw-loader/dist/cjs.js!./src/app/display/display.component.html ***!
  \***************************************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<div class=\"wrapper\" *ngIf=\"results && results.length > 0 && results[0]\">\n  <div class=\"row top-line\">\n    <div class=\"col-4 align-self-center\">\n      <span class=\"size-2 item-1\">Line {{ results[0].line_name }}</span>\n    </div>\n    <div class=\"col-4 text-center align-self-center\">\n      <span class=\"size-2 item-1\">{{ currentDate }}</span>\n    </div>\n    <div class=\"col-4 text-right mt-2\">\n      <span class=\"size-3 clock\">{{ currentHours }}</span>\n    </div>\n  </div>\n  <div class=\"row sub-line pt-1 pb-1\">\n    <div class=\"col-4 align-self-center\">\n      <span class=\"size-1\">{{ results[0].part_name || '&nbsp;' }}</span>\n    </div>\n    <div class=\"col-4 text-center align-self-center\">\n      <span class=\"size-1 item-2\">CT. {{ results[0].cycle_time_minute }} menit</span>\n    </div>\n    <div class=\"col-4 text-right align-self-center\">\n      <span class=\"size-1 item-2\">{{ results[0].mobility_order_number || '&nbsp;' }}</span>\n    </div>\n  </div>\n  <div class=\"row mid-content p-2\">\n    <div class=\"col-3\">\n      <div class=\"row\">\n        <div class=\"col border m-1 height-2\">\n          <span class=\"size-2\">Qty Target (Total)</span>\n          <div class=\"text-center size-4\">\n            {{ results[0].production_scale.toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 2 }) }}\n          </div>\n          <div class=\"text-right align-self-bottom\">{{ results[0].unit_name || '&nbsp;' }}</div>\n        </div>\n      </div>\n      <div class=\"row\">\n        <div class=\"col border m-1 height-2\">\n          <span class=\"size-2 text-danger\">Qty Aktual</span>\n          <div class=\"text-center size-4 text-danger\">\n            {{ results[0].delivered.toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 2 }) }}\n          </div>\n          <div class=\"text-right align-self-bottom text-danger\">{{ results[0].unit_name || '&nbsp;' }}</div>\n        </div>\n      </div>\n    </div>\n    <div class=\"col-3\">\n      <div class=\"row\">\n        <div class=\"col border m-1 height-2\">\n          <span class=\"size-2\">Qty Target (In Process)</span>\n          <div class=\"text-center size-4\">\n            {{ results[0].production_in_process.toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 2 }) }}\n          </div>\n          <div class=\"text-right align-self-bottom\">{{ results[0].unit_name || '&nbsp;' }}</div>\n        </div>\n      </div>\n      <div class=\"row\">\n        <div class=\"col border m-1 height-2\">\n          <span class=\"size-2 text-danger\">Balance</span>\n          <div class=\"text-center size-4 text-danger\">\n            {{ results[0].balance.toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 2 }) }}\n          </div>\n          <div class=\"text-right align-self-bottom text-danger\">{{ results[0].unit_name || '&nbsp;' }}</div>\n        </div>\n      </div>\n    </div>\n    <div class=\"col-3\">\n      <div class=\"row\">\n        <div class=\"col border m-1 height-2\">\n          <span class=\"size-2\" [ngClass]=\"{'text-warning': isPause}\">Waktu Berlalu</span>\n          <div class=\"text-right size-4 clock\" [ngClass]=\"{'text-warning': isPause}\">\n            {{ elapsedTimeInSeconds | secondsToHms }}\n          </div>\n          <div>&nbsp;</div>\n        </div>\n      </div>\n      <div class=\"row\">\n        <div class=\"col border m-1 height-2\">\n          <span class=\"size-2\" [ngClass]=\"{'text-danger': visibleMinusLeftTime && !isPause, 'text-warning': isPause}\">Waktu Tersisa</span>\n          <div class=\"text-right size-4 clock\" [ngClass]=\"{'text-danger': visibleMinusLeftTime && !isPause, 'text-warning': isPause}\">\n            {{ (visibleMinusLeftTime) ? '-' : '&nbsp;' }}{{ leftTimeInSeconds | secondsToHms }}\n          </div>\n          <div>&nbsp;</div>\n        </div>\n      </div>\n    </div>\n    <div class=\"col-3\" style=\"display: flex; flex-direction: column;\">\n      <div class=\"row\">\n        <div class=\"col border m-1 height-1\">\n          <div class=\"row text-center\">\n            <div class=\"col-6\">\n              <span class=\"size-2\">Start</span>\n              <div class=\"text-center clock-item clock\">\n                {{ startAt ? (startAt | date: 'HH:mm') : '00:00' }}</div>\n            </div>\n            <div class=\"col-6\">\n              <span class=\"size-2\">Target Finish</span>\n              <div class=\"text-center clock-item clock\">\n                {{ targetFinishAt ? (targetFinishAt | date: 'HH:mm') : '00:00' }}</div>\n            </div>\n          </div>\n        </div>\n      </div>\n      <div class=\"row\" style=\"margin-top: 0.50rem !important; margin-bottom: 0.50em !important; flex: 1;\">\n        <div class=\"col border m-1 height-1 text-center\">\n          <span class=\"size-2\">OEE (%)</span>\n          <div style=\"position: relative; height: 15vh; margin: 0.50em\" class=\"text-center\">\n            <canvas #oee_chart></canvas>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n  <div class=\"row bottom-content mt-2\">\n    <div class=\"col-8 prod-data\">\n      <div class=\"text-center p-2 title\">Item Production List</div>\n      <table class=\"table\">\n        <thead>\n          <tr class=\"text-center\">\n            <th>&nbsp;</th>\n            <th scope=\"col\" class=\"col-title\">Product</th>\n            <th scope=\"col\" class=\"col-title\">Mobility Order</th>\n            <th scope=\"col\" class=\"col-title\">Qty. Plan</th>\n            <th scope=\"col\" class=\"col-title\">Aktual</th>\n            <th scope=\"col\" class=\"col-title\">No. Batch</th>\n            <th scope=\"col\" class=\"col-title\">Status</th>\n            <th scope=\"col\" class=\"col-title\">Loss Time</th>\n            <th scope=\"col\" class=\"col-title\">Start</th>\n            <th scope=\"col\" class=\"col-title\">Finish</th>\n          </tr>\n        </thead>\n        <tbody *ngFor=\"let data of listMobilityOrders\">\n          <tr>\n            <td><i class=\"fas fa-circle {{ data.last_processed_status | lowercase }}\"></i></td>\n            <td>{{ data.part_name }}</td>\n            <td class=\"text-center\">{{ data.mobility_order_number }}</td>\n            <td class=\"text-center\">\n              {{ data.production_scale.toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 2 }) }}\n            </td>\n            <td class=\"text-center\">\n              {{ (data.last_processed_status !== 'Planned') ? (data.delivered.toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 2 })) : '-' }}\n            </td>\n            <td class=\"text-center\">{{ data.batch_number }}</td>\n            <td class=\"text-center\">{{ data.last_processed_status }}</td>\n            <td class=\"text-center font-weight-bold\" [ngClass]=\"(data.last_processed_status !== 'Planned' && data.loss_time_minute > 0) ? 'danger-text' : ''\">\n              {{ (data.last_processed_status !== 'Planned') ? data.loss_time_minute.toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 2 }) + \" '\" : '-' }}\n            </td>\n            <td class=\"text-center\">\n              {{ (data.last_processed_status !== 'Planned' && data.start) ? (data.start | date: 'HH:mm') : '-' }}\n            </td>\n            <td class=\"text-center\">\n              {{ (data.last_processed_status !== 'Planned' && data.finish) ? (data.finish | date: 'HH:mm') : '-' }}\n            </td>\n          </tr>\n        </tbody>\n      </table>\n    </div>\n    <div class=\"col-4\">\n      <div class=\"row ml-2 mr-2 mt-4 text-center stat-data\">\n        <div class=\"col-4 border\">\n          <div class=\"mt-1 title\">Dandori</div>\n          <div class=\"row\">\n            <div class=\"col border-bottom border-5\">\n              <div class=\"row\">\n                <div class=\"col-12 text-right\">\n                  <span class=\"size-1\">{{ results[0].dandori.toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 2 }) }}</span>&nbsp;<span class=\"small-text\">mnt</span>\n                </div>\n              </div>\n            </div>\n            <div class=\"w-100\"></div>\n            <div class=\"col\">\n              <div class=\"row\">\n                <div class=\"col-12 text-right\">\n                  <span class=\"size-2\">{{ results[0].dandori_rate.toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 2 }) }}</span>&nbsp;<span class=\"small-text\">%</span>\n                </div>\n              </div>\n            </div>\n          </div>\n        </div>\n        <div class=\"col-4 border\">\n          <div class=\"mt-1 title\">Downtime</div>\n          <div class=\"row\">\n            <div class=\"col border-bottom border-5\">\n              <div class=\"row\">\n                <div class=\"col-12 text-right\">\n                  <span class=\"size-1\">{{ counter.downtime.toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 2 }) }}</span>&nbsp;<span class=\"small-text\">mnt</span>\n                </div>\n              </div>\n            </div>\n            <div class=\"w-100\"></div>\n            <div class=\"col\">\n              <div class=\"row\">\n                <div class=\"col-12 text-right\">\n                  <span class=\"size-2\">{{ counter.downtime_rate.toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 2 }) }}</span>&nbsp;<span class=\"small-text\">%</span>\n                </div>\n              </div>\n            </div>\n          </div>\n        </div>\n        <div class=\"col-4 border\">\n          <div class=\"mt-1 title\">Quality</div>\n          <div class=\"row\">\n            <div class=\"col border-bottom border-5\">\n              <div class=\"row\">\n                <div class=\"col-12 text-center\">\n                  <span\n                    class=\"size-1\">{{ results[0].quality_delivered.toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 2 }) }}/{{ results[0].quality_rejected.toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 2 }) }}</span>\n                </div>\n              </div>\n            </div>\n            <div class=\"w-100\"></div>\n            <div class=\"col\">\n              <div class=\"row\">\n                <div class=\"col-12 text-right\">\n                  <span class=\"size-2\">{{ results[0].ratio_ng_rate.toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 2 }) }}</span>&nbsp;<span class=\"small-text\">%</span>\n                </div>\n              </div>\n            </div>\n          </div>\n        </div>\n      </div>\n      <div class=\"row ml-2 mr-2 text-center chart-data\">\n        <div class=\"col-4 border\">\n          <div class=\"title\">Availability (%)</div>\n          <div class=\"item-chart\">\n            <canvas #availability_chart></canvas>\n          </div>\n        </div>\n        <div class=\"col-4 border\">\n          <div class=\"title\">Performance (%)</div>\n          <div class=\"item-chart\">\n            <canvas #performance_chart></canvas>\n          </div>\n        </div>\n        <div class=\"col-4 border\">\n          <div class=\"title\">Quality (%)</div>\n          <div class=\"item-chart\">\n            <canvas #quality_chart></canvas>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n");

/***/ }),

/***/ "../../node_modules/tslib/tslib.es6.js":
/*!******************************************************************************!*\
  !*** /home/administrator/app/mobility-tv-v2/node_modules/tslib/tslib.es6.js ***!
  \******************************************************************************/
/*! exports provided: __extends, __assign, __rest, __decorate, __param, __metadata, __awaiter, __generator, __exportStar, __values, __read, __spread, __spreadArrays, __await, __asyncGenerator, __asyncDelegator, __asyncValues, __makeTemplateObject, __importStar, __importDefault */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__extends", function() { return __extends; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__assign", function() { return __assign; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__rest", function() { return __rest; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__decorate", function() { return __decorate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__param", function() { return __param; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__metadata", function() { return __metadata; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__awaiter", function() { return __awaiter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__generator", function() { return __generator; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__exportStar", function() { return __exportStar; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__values", function() { return __values; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__read", function() { return __read; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__spread", function() { return __spread; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__spreadArrays", function() { return __spreadArrays; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__await", function() { return __await; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__asyncGenerator", function() { return __asyncGenerator; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__asyncDelegator", function() { return __asyncDelegator; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__asyncValues", function() { return __asyncValues; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__makeTemplateObject", function() { return __makeTemplateObject; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__importStar", function() { return __importStar; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__importDefault", function() { return __importDefault; });
/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    }
    return __assign.apply(this, arguments);
}

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}

function __param(paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
}

function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}

function __awaiter(thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

function __exportStar(m, exports) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}

function __values(o) {
    var m = typeof Symbol === "function" && o[Symbol.iterator], i = 0;
    if (m) return m.call(o);
    return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
}

function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}

function __spread() {
    for (var ar = [], i = 0; i < arguments.length; i++)
        ar = ar.concat(__read(arguments[i]));
    return ar;
}

function __spreadArrays() {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};

function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}

function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i;
    function verb(n) { if (g[n]) i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; }
    function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
    function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r); }
    function fulfill(value) { resume("next", value); }
    function reject(value) { resume("throw", value); }
    function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
}

function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function (e) { throw e; }), verb("return"), i[Symbol.iterator] = function () { return this; }, i;
    function verb(n, f) { i[n] = o[n] ? function (v) { return (p = !p) ? { value: __await(o[n](v)), done: n === "return" } : f ? f(v) : v; } : f; }
}

function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
    function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
    function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
}

function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};

function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result.default = mod;
    return result;
}

function __importDefault(mod) {
    return (mod && mod.__esModule) ? mod : { default: mod };
}


/***/ }),

/***/ "./$$_lazy_route_resource lazy recursive":
/*!******************************************************!*\
  !*** ./$$_lazy_route_resource lazy namespace object ***!
  \******************************************************/
/*! no static exports found */
/***/ (function(module, exports) {

function webpackEmptyAsyncContext(req) {
	// Here Promise.resolve().then() is used instead of new Promise() to prevent
	// uncaught exception popping up in devtools
	return Promise.resolve().then(function() {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	});
}
webpackEmptyAsyncContext.keys = function() { return []; };
webpackEmptyAsyncContext.resolve = webpackEmptyAsyncContext;
module.exports = webpackEmptyAsyncContext;
webpackEmptyAsyncContext.id = "./$$_lazy_route_resource lazy recursive";

/***/ }),

/***/ "./src/app/app.component.scss":
/*!************************************!*\
  !*** ./src/app/app.component.scss ***!
  \************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("html {\n  box-sizing: border-box;\n}\n\n*,\n*::before,\n*::after {\n  box-sizing: inherit;\n}\n\nbody {\n  -ms-overflow-style: scrollbar;\n}\n\na,\narea,\nbutton,\n[role=button],\ninput,\nlabel,\nselect,\nsummary,\ntextarea {\n  touch-action: manipulation;\n}\n\n.grow {\n  flex: 1;\n}\n\n.main {\n  overflow-y: auto;\n}\n\n.hide {\n  visibility: hidden;\n}\n\n.show {\n  visibility: unset;\n}\n\n.wrapper {\n  background-color: #314861;\n  height: 100%;\n}\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi9ob21lL2FkbWluaXN0cmF0b3IvYXBwL21vYmlsaXR5LXR2LXYyL2FwcHMvbW9iaWxpdHktdHYvc3JjL2FwcC9hcHAuY29tcG9uZW50LnNjc3MiLCJhcHBzL21vYmlsaXR5LXR2L3NyYy9hcHAvYXBwLmNvbXBvbmVudC5zY3NzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBO0VBQ0Usc0JBQUE7QUNDRjs7QURDQTs7O0VBR0UsbUJBQUE7QUNFRjs7QURDQTtFQUNFLDZCQUFBO0FDRUY7O0FEQ0E7Ozs7Ozs7OztFQVNFLDBCQUFBO0FDRUY7O0FEQ0E7RUFDRSxPQUFBO0FDRUY7O0FEQ0E7RUFDRSxnQkFBQTtBQ0VGOztBRENBO0VBQ0Usa0JBQUE7QUNFRjs7QURDQTtFQUNFLGlCQUFBO0FDRUY7O0FEQ0E7RUFDRSx5QkFBQTtFQUNBLFlBQUE7QUNFRiIsImZpbGUiOiJhcHBzL21vYmlsaXR5LXR2L3NyYy9hcHAvYXBwLmNvbXBvbmVudC5zY3NzIiwic291cmNlc0NvbnRlbnQiOlsiaHRtbCB7XG4gIGJveC1zaXppbmc6IGJvcmRlci1ib3g7XG59XG4qLFxuKjo6YmVmb3JlLFxuKjo6YWZ0ZXIge1xuICBib3gtc2l6aW5nOiBpbmhlcml0O1xufVxuXG5ib2R5IHtcbiAgLW1zLW92ZXJmbG93LXN0eWxlOiBzY3JvbGxiYXI7XG59XG5cbmEsXG5hcmVhLFxuYnV0dG9uLFxuW3JvbGU9J2J1dHRvbiddLFxuaW5wdXQsXG5sYWJlbCxcbnNlbGVjdCxcbnN1bW1hcnksXG50ZXh0YXJlYSB7XG4gIHRvdWNoLWFjdGlvbjogbWFuaXB1bGF0aW9uO1xufVxuXG4uZ3JvdyB7XG4gIGZsZXg6IDE7XG59XG5cbi5tYWluIHtcbiAgb3ZlcmZsb3cteTogYXV0bztcbn1cblxuLmhpZGUge1xuICB2aXNpYmlsaXR5OiBoaWRkZW47XG59XG5cbi5zaG93IHtcbiAgdmlzaWJpbGl0eTogdW5zZXQ7XG59XG5cbi53cmFwcGVyIHtcbiAgYmFja2dyb3VuZC1jb2xvcjogIzMxNDg2MTtcbiAgaGVpZ2h0OiAxMDAlO1xufVxuIiwiaHRtbCB7XG4gIGJveC1zaXppbmc6IGJvcmRlci1ib3g7XG59XG5cbiosXG4qOjpiZWZvcmUsXG4qOjphZnRlciB7XG4gIGJveC1zaXppbmc6IGluaGVyaXQ7XG59XG5cbmJvZHkge1xuICAtbXMtb3ZlcmZsb3ctc3R5bGU6IHNjcm9sbGJhcjtcbn1cblxuYSxcbmFyZWEsXG5idXR0b24sXG5bcm9sZT1idXR0b25dLFxuaW5wdXQsXG5sYWJlbCxcbnNlbGVjdCxcbnN1bW1hcnksXG50ZXh0YXJlYSB7XG4gIHRvdWNoLWFjdGlvbjogbWFuaXB1bGF0aW9uO1xufVxuXG4uZ3JvdyB7XG4gIGZsZXg6IDE7XG59XG5cbi5tYWluIHtcbiAgb3ZlcmZsb3cteTogYXV0bztcbn1cblxuLmhpZGUge1xuICB2aXNpYmlsaXR5OiBoaWRkZW47XG59XG5cbi5zaG93IHtcbiAgdmlzaWJpbGl0eTogdW5zZXQ7XG59XG5cbi53cmFwcGVyIHtcbiAgYmFja2dyb3VuZC1jb2xvcjogIzMxNDg2MTtcbiAgaGVpZ2h0OiAxMDAlO1xufSJdfQ== */");

/***/ }),

/***/ "./src/app/app.component.ts":
/*!**********************************!*\
  !*** ./src/app/app.component.ts ***!
  \**********************************/
/*! exports provided: AppComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AppComponent", function() { return AppComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "../../node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "../../node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_common_http__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/common/http */ "../../node_modules/@angular/common/fesm2015/http.js");
/* harmony import */ var rxjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! rxjs */ "../../node_modules/rxjs/_esm2015/index.js");
/* harmony import */ var rxjs_operators__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! rxjs/operators */ "../../node_modules/rxjs/_esm2015/operators/index.js");
/* harmony import */ var _services__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./services */ "./src/app/services/index.ts");



// import { interval } from 'rxjs/internal/observable/interval';




let AppComponent = class AppComponent {
    constructor(env, dataService) {
        this.env = env;
        this.dataService = dataService;
        this.title = 'app';
        this.errorMessage = '';
        this.errorCode = '';
        this.results = [];
        //
        if (this.env.enableDebug) {
            console.log(`set polling interval: ${env.interval} ms`);
        }
        this.display = false;
        this.alive = true;
        this.interval = env.interval;
    }
    ngOnInit() {
        // fetch data
        // const group = '5d22b2c7995c3da301c15b48';
        this.errorCode = '';
        this.errorMessage = '';
        this.results = [];
        const id = this._getParamValue('p');
        if (!id) {
            this.errorMessage = 'Parameter not found';
            // tslint:disable-next-line: deprecation
            return Object(rxjs__WEBPACK_IMPORTED_MODULE_3__["empty"])();
        }
        this.runData();
    }
    ngOnDestroy() {
        this.alive = false;
    }
    runData() {
        const data$ = this.dataService.getData(this._getParamValue('p'));
        // const data$ = this.dataService.getJSON(this._getParamValue('p'));
        const trigger$ = Object(rxjs__WEBPACK_IMPORTED_MODULE_3__["timer"])(0, this.env.interval);
        trigger$
            .pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_4__["switchMap"])(() => {
            return data$
                .pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_4__["catchError"])((err) => this.handleError(err)));
        }))
            .subscribe((res) => {
            if (res && res.result && res.resultData.data.length > 0) {
                this.results = res.resultData.data;
                if (!this.display) {
                    this.display = true;
                }
                console.log('>> group-line updated: ', res.resultData.last_update);
            }
            else {
                console.error('Invalid result.');
                this.errorMessage = 'Invalid result';
            }
        }, (err) => {
            console.error('HTTP error: ', err);
            this.errorCode = err && err.error && err.error.statusCode || err.status;
            this.errorMessage = err && err.error && err.error.message || err.statusText;
        }, () => {
            if (!this.errorMessage && this.results.length === 0) {
                this.errorMessage = 'Invalid parameter';
            }
            console.log('HTTP request completed.');
        });
    }
    handleError(err) {
        console.error(err);
        if (err.status === 404) {
            throw err;
        }
        // tslint:disable-next-line: deprecation
        return Object(rxjs__WEBPACK_IMPORTED_MODULE_3__["empty"])();
    }
    _getParamValue(paramName) {
        const url = window.location.href;
        let paramValue;
        if (url.includes('?')) {
            const httpParams = new _angular_common_http__WEBPACK_IMPORTED_MODULE_2__["HttpParams"]({ fromString: url.split('?')[1] });
            paramValue = httpParams.get(paramName);
        }
        return paramValue;
    }
};
AppComponent.ctorParameters = () => [
    { type: _services__WEBPACK_IMPORTED_MODULE_5__["EnvService"] },
    { type: _services__WEBPACK_IMPORTED_MODULE_5__["DataService"] }
];
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Input"])(),
    tslib__WEBPACK_IMPORTED_MODULE_0__["__metadata"]("design:type", Array)
], AppComponent.prototype, "results", void 0);
AppComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'mobility-tv-root',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./app.component.html */ "../../node_modules/raw-loader/dist/cjs.js!./src/app/app.component.html")).default,
        providers: [_services__WEBPACK_IMPORTED_MODULE_5__["DataService"]],
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./app.component.scss */ "./src/app/app.component.scss")).default]
    }),
    tslib__WEBPACK_IMPORTED_MODULE_0__["__metadata"]("design:paramtypes", [_services__WEBPACK_IMPORTED_MODULE_5__["EnvService"],
        _services__WEBPACK_IMPORTED_MODULE_5__["DataService"]])
], AppComponent);



/***/ }),

/***/ "./src/app/app.module.ts":
/*!*******************************!*\
  !*** ./src/app/app.module.ts ***!
  \*******************************/
/*! exports provided: AppModule */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AppModule", function() { return AppModule; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "../../node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_platform_browser__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/platform-browser */ "../../node_modules/@angular/platform-browser/fesm2015/platform-browser.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/core */ "../../node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_common_http__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @angular/common/http */ "../../node_modules/@angular/common/fesm2015/http.js");
/* harmony import */ var _angular_forms__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @angular/forms */ "../../node_modules/@angular/forms/fesm2015/forms.js");
/* harmony import */ var ngx_bootstrap_modal__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ngx-bootstrap/modal */ "../../node_modules/ngx-bootstrap/modal/fesm2015/ngx-bootstrap-modal.js");
/* harmony import */ var ngx_select_ex__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ngx-select-ex */ "../../node_modules/ngx-select-ex/fesm2015/ngx-select-ex.js");
/* harmony import */ var _fortawesome_angular_fontawesome__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @fortawesome/angular-fontawesome */ "../../node_modules/@fortawesome/angular-fontawesome/fesm2015/angular-fontawesome.js");
/* harmony import */ var _app_component__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./app.component */ "./src/app/app.component.ts");
/* harmony import */ var _services__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ./services */ "./src/app/services/index.ts");
/* harmony import */ var _display_display_component__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ./display/display.component */ "./src/app/display/display.component.ts");
/* harmony import */ var _pipes_minute_second_pipe__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ./pipes/minute-second.pipe */ "./src/app/pipes/minute-second.pipe.ts");
/* harmony import */ var _pipes_second_hms_pipe__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ./pipes/second-hms.pipe */ "./src/app/pipes/second-hms.pipe.ts");













let AppModule = class AppModule {
};
AppModule = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_2__["NgModule"])({
        declarations: [
            _app_component__WEBPACK_IMPORTED_MODULE_8__["AppComponent"],
            _display_display_component__WEBPACK_IMPORTED_MODULE_10__["DisplayComponent"],
            _pipes_minute_second_pipe__WEBPACK_IMPORTED_MODULE_11__["MinuteSecondsPipe"],
            _pipes_second_hms_pipe__WEBPACK_IMPORTED_MODULE_12__["SecondsToHmsPipe"]
        ],
        imports: [
            _angular_platform_browser__WEBPACK_IMPORTED_MODULE_1__["BrowserModule"],
            _angular_forms__WEBPACK_IMPORTED_MODULE_4__["FormsModule"],
            _angular_forms__WEBPACK_IMPORTED_MODULE_4__["ReactiveFormsModule"],
            _angular_common_http__WEBPACK_IMPORTED_MODULE_3__["HttpClientModule"],
            ngx_select_ex__WEBPACK_IMPORTED_MODULE_6__["NgxSelectModule"],
            _fortawesome_angular_fontawesome__WEBPACK_IMPORTED_MODULE_7__["FontAwesomeModule"],
            ngx_bootstrap_modal__WEBPACK_IMPORTED_MODULE_5__["ModalModule"].forRoot()
        ],
        providers: [
            _services__WEBPACK_IMPORTED_MODULE_9__["EnvServiceProvider"],
        ],
        bootstrap: [_app_component__WEBPACK_IMPORTED_MODULE_8__["AppComponent"]],
        entryComponents: []
    })
], AppModule);



/***/ }),

/***/ "./src/app/display/display.component.scss":
/*!************************************************!*\
  !*** ./src/app/display/display.component.scss ***!
  \************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (".wrapper {\n  background-color: #314861;\n  height: 100%;\n  padding-left: 24px;\n  padding-right: 24px;\n  padding-top: 4px;\n}\n\n.top-line {\n  color: white;\n}\n\n.top-line .item-1 {\n  font-weight: bold;\n}\n\n.top-line .icon-font {\n  font-size: 3vw;\n  margin-left: 15px;\n  vertical-align: top;\n}\n\n.top-line .size-1 {\n  font-size: 1.5vw;\n}\n\n.top-line .size-2 {\n  font-size: 2.5vw;\n}\n\n.top-line .size-3 {\n  font-size: 3.5vw;\n}\n\n.sub-line {\n  background-color: #7d8f9b;\n}\n\n.sub-line .size-1 {\n  font-size: 2vw;\n}\n\n.sub-line .size-2 {\n  font-size: 2.25vw;\n}\n\n.sub-line .item-1 {\n  font-weight: bold;\n}\n\n.sub-line .item-2 {\n  font-weight: bold;\n  color: white;\n}\n\n.mid-content {\n  background-color: #111315;\n  color: white;\n}\n\n.mid-content .height-1 {\n  height: 100%;\n}\n\n.mid-content .height-2 {\n  height: 100%;\n}\n\n.mid-content .height-3 {\n  height: 100%;\n}\n\n.mid-content .size-2 {\n  font-size: 1.35vw;\n  font-weight: bold;\n}\n\n.mid-content .size-3 {\n  font-size: 3.5vw;\n  font-weight: bold;\n}\n\n.mid-content .size-4 {\n  font-size: 4.2vw;\n  line-height: 1.2em;\n  font-weight: bold;\n}\n\n.mid-content .clock-item {\n  font-size: 2.35vw;\n}\n\n.bottom-content {\n  background-color: #616f78;\n}\n\n.bottom-content td {\n  color: white;\n}\n\n.bottom-content .danger-text {\n  color: red;\n  font-weight: 500;\n}\n\n.table-light-grey {\n  background-color: #7d8f9b;\n}\n\n.prod-data {\n  color: white;\n}\n\n.prod-data thead tr {\n  color: white;\n}\n\n.prod-data table td {\n  padding: 6px;\n}\n\n.prod-data table td .completed {\n  color: aqua;\n}\n\n.prod-data table td .tobecompleted {\n  color: aqua;\n}\n\n.prod-data table td .preparation {\n  color: lawngreen;\n}\n\n.prod-data table td .planned {\n  color: red;\n}\n\n.prod-data table td .active {\n  color: deepskyblue;\n}\n\n.prod-data table td .integrated {\n  color: aqua;\n}\n\n.prod-data .title {\n  font-size: 1.3vw;\n  font-weight: bold;\n}\n\n.prod-data .col-title {\n  font-size: 1vw;\n  font-weight: bold;\n}\n\n.prod-data .col-body {\n  font-size: 0.86vw;\n}\n\n.stat-data {\n  color: white;\n}\n\n.stat-data .row {\n  padding-top: 0.5em;\n  padding-bottom: 0.5em;\n}\n\n.stat-data .title {\n  font-size: 1.15vw;\n  font-weight: bold;\n}\n\n.stat-data .size-1 {\n  font-size: 1.5vw;\n  font-weight: bold;\n}\n\n.stat-data .size-2 {\n  font-size: 2vw;\n  font-weight: bold;\n}\n\n.stat-data .size-3 {\n  font-size: 3.5vw;\n  font-weight: bold;\n}\n\n.stat-data .col-4 {\n  padding-top: 1em;\n}\n\n.stat-data .border-5 {\n  padding-bottom: 0.5em;\n}\n\n.chart-data {\n  color: white;\n}\n\n.chart-data .item-chart {\n  padding: 4px;\n  margin-left: 10px;\n}\n\n.chart-data .title {\n  font-size: 0.9vw;\n  font-weight: bold;\n  padding-bottom: 1em !important;\n}\n\n.chart-data .col-3 {\n  padding-top: 1em !important;\n  padding-bottom: 1em !important;\n}\n\n.chart-data .col-4 {\n  padding-top: 1em;\n  padding-bottom: 1em;\n}\n\n.border-3 {\n  border-width: 3px !important;\n}\n\n.border-5 {\n  border-width: 5px !important;\n}\n\n.bottom-align-text {\n  position: absolute;\n  bottom: 0;\n  right: 0;\n}\n\n.small-text {\n  font-size: 1vw;\n}\n/*# sourceMappingURL=data:application/json;base64,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 */");

/***/ }),

/***/ "./src/app/display/display.component.ts":
/*!**********************************************!*\
  !*** ./src/app/display/display.component.ts ***!
  \**********************************************/
/*! exports provided: DisplayComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DisplayComponent", function() { return DisplayComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "../../node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "../../node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_common_http__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/common/http */ "../../node_modules/@angular/common/fesm2015/http.js");
/* harmony import */ var rxjs_internal_observable_interval__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! rxjs/internal/observable/interval */ "../../node_modules/rxjs/internal/observable/interval.js");
/* harmony import */ var rxjs_internal_observable_interval__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(rxjs_internal_observable_interval__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var rxjs_operators__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! rxjs/operators */ "../../node_modules/rxjs/_esm2015/operators/index.js");
/* harmony import */ var luxon__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! luxon */ "../../node_modules/luxon/build/cjs-browser/luxon.js");
/* harmony import */ var luxon__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(luxon__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _services__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../services */ "./src/app/services/index.ts");
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! moment */ "../../node_modules/moment/moment.js");
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(moment__WEBPACK_IMPORTED_MODULE_7__);








let DisplayComponent = class DisplayComponent {
    constructor(env, chartService) {
        this.env = env;
        this.chartService = chartService;
        this.title = 'mobility-tv';
        this.hasContent = false;
        this.loadingText = 'Fetching data ...';
        this.serverTime = null;
        this.elapsedTimeInSeconds = 0;
        this.leftTimeInSeconds = 0;
        this.visibleMinusLeftTime = false;
        this.listMobilityOrders = [];
        this.isPause = false;
        this.counterUpdate = 0;
        this.charts = [];
        this.results = [];
        this.counter = {
            downtime: 0,
            downtime_rate: 0,
            elapsed_time_second: 0,
            elapsed_time_minute: 0,
            time_left_second: 0,
            time_left_minute: 0,
            production_efficiency_rate: 0,
            performance_rate: 0,
            production_availability_rate: 0,
            quality_rate: 0,
            oee_rate: 0
        };
        //
    }
    ngOnInit() {
        // get param
        this.lineGroup = this._getParamValueQueryString('line_group');
        this.fillInProperties();
        this.startClock();
    }
    ngAfterViewInit() {
        this._run();
    }
    reload() {
        window.location.reload();
    }
    startClock() {
        Object(rxjs_internal_observable_interval__WEBPACK_IMPORTED_MODULE_3__["interval"])(1000)
            .pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_4__["startWith"])(0)).subscribe((val) => {
            if (this.counterUpdate < (this.env.interval / 1000)) {
                this.counterUpdate++;
            }
            else {
                this.counterUpdate = 0;
                this.fillInProperties();
            }
            const now = luxon__WEBPACK_IMPORTED_MODULE_5__["DateTime"].local().setLocale('ID');
            this.currentDate = now.weekdayLong + ', ' + now.toFormat('dd-MMM-yyyy');
            this.currentHours = now.toFormat('HH:mm:ss');
            if (this.serverTime) {
                this.serverTime = moment__WEBPACK_IMPORTED_MODULE_7__(this.serverTime).add(1, 'seconds');
                this.currentDate = this.serverTime.lang('ID').format('dddd, DD-MMM-YYYY');
                this.currentHours = this.serverTime.format('HH:mm:ss');
            }
            if (!this.isPause && this.elapsedTimeInSeconds > 0) {
                this.elapsedTimeInSeconds++;
                if (this.leftTimeInSeconds <= 0) {
                    this.leftTimeInSeconds = Math.abs(this.leftTimeInSeconds);
                    this.visibleMinusLeftTime = true;
                }
                if (!this.visibleMinusLeftTime) {
                    this.leftTimeInSeconds--;
                    if (this.leftTimeInSeconds < 0) {
                        this.visibleMinusLeftTime = true;
                    }
                }
                else {
                    this.leftTimeInSeconds++;
                }
            }
        });
    }
    _run() {
        this._startBuildingChart(this.lineGroup);
    }
    _getChartValue(val) {
        let dataMax = 100;
        let dataMin = 0;
        if (val < 100) {
            dataMax = val;
            dataMin = 100 - val;
        }
        return [val, dataMax, dataMin];
    }
    _startBuildingChart(lineGroup) {
        this.efficiencyChartElementRefs.map((chartElementRef, index) => {
            return this.chartService.buildEfisiensi(chartElementRef.nativeElement, this._getChartValue(this.counter.production_efficiency_rate));
        });
        this.availabilityChartElementRefs.map((chartElementRef, index) => {
            return this.chartService.buildAvailability(chartElementRef.nativeElement, this._getChartValue(this.counter.performance_rate));
        });
        this.performanceChartElementRefs.map((chartElementRef, index) => {
            return this.chartService.buildPerformance(chartElementRef.nativeElement, this._getChartValue(this.counter.production_availability_rate));
        });
        this.qualityChartElementRefs.map((chartElementRef, index) => {
            return this.chartService.buildQuality(chartElementRef.nativeElement, this._getChartValue(this.counter.quality_rate));
        });
        this.oeeChartElementRefs.map((chartElementRef, index) => {
            return this.chartService.buildOEE(chartElementRef.nativeElement, this._getChartValue(this.counter.oee_rate));
        });
    }
    _getParamValueQueryString(paramName) {
        const url = window.location.href;
        let paramValue;
        if (url.includes('?')) {
            const httpParams = new _angular_common_http__WEBPACK_IMPORTED_MODULE_2__["HttpParams"]({ fromString: url.split('?')[1] });
            paramValue = httpParams.get(paramName);
        }
        return paramValue;
    }
    fillInProperties() {
        this.counter.downtime = Number(this.results[0].downtime.toFixed(2));
        this.counter.downtime_rate = Number(this.results[0].downtime_rate.toFixed(2));
        this.counter.elapsed_time_second = Number(this.results[0].elapsed_time_second.toFixed(2));
        this.counter.elapsed_time_minute = Number(this.results[0].elapsed_time_minute.toFixed(2));
        this.counter.time_left_second = Number(this.results[0].time_left_second.toFixed(2));
        this.counter.time_left_minute = Number(this.results[0].time_left_minute.toFixed(2));
        this.counter.production_efficiency_rate = Number(this.results[0].production_efficiency_rate.toFixed(2));
        this.counter.performance_rate = Number(this.results[0].production_availability_rate.toFixed(2));
        this.counter.production_availability_rate = Number(this.results[0].performance_rate.toFixed(2));
        this.counter.quality_rate = Number(this.results[0].quality_rate.toFixed(2));
        this.counter.oee_rate = Number(this.results[0].oee_rate.toFixed(2));
        this.elapsedTimeInSeconds = this.counter.elapsed_time_second;
        this.visibleMinusLeftTime = false;
        this.leftTimeInSeconds = this.counter.time_left_second;
        if (this.counter.time_left_second < 0) {
            this.visibleMinusLeftTime = true;
            this.leftTimeInSeconds = this.leftTimeInSeconds * -1;
        }
        this.isPause = this.results[0].is_pause;
        const serverTime = this.results[0] && this.results[0].server_time || null;
        this.serverTime = null;
        if (serverTime && moment__WEBPACK_IMPORTED_MODULE_7__(serverTime).isValid()) {
            this.serverTime = moment__WEBPACK_IMPORTED_MODULE_7__(serverTime);
        }
        this.startAt = this.results[0] && this.results[0].start_at || null;
        this.targetFinishAt = this.results[0] && this.results[0].target_finish_at || null;
        const listMobilityOrders = this.results[0].mobility_orders || [];
        const maxListMobilityOrders = 10;
        listMobilityOrders.length = Math.min(listMobilityOrders.length, maxListMobilityOrders);
        this.listMobilityOrders = listMobilityOrders;
    }
};
DisplayComponent.ctorParameters = () => [
    { type: _services__WEBPACK_IMPORTED_MODULE_6__["EnvService"] },
    { type: _services__WEBPACK_IMPORTED_MODULE_6__["ChartService"] }
];
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["ViewChildren"])('efisiensi_chart', { read: _angular_core__WEBPACK_IMPORTED_MODULE_1__["ElementRef"] }),
    tslib__WEBPACK_IMPORTED_MODULE_0__["__metadata"]("design:type", _angular_core__WEBPACK_IMPORTED_MODULE_1__["QueryList"])
], DisplayComponent.prototype, "efficiencyChartElementRefs", void 0);
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["ViewChildren"])('availability_chart', { read: _angular_core__WEBPACK_IMPORTED_MODULE_1__["ElementRef"] }),
    tslib__WEBPACK_IMPORTED_MODULE_0__["__metadata"]("design:type", _angular_core__WEBPACK_IMPORTED_MODULE_1__["QueryList"])
], DisplayComponent.prototype, "availabilityChartElementRefs", void 0);
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["ViewChildren"])('performance_chart', { read: _angular_core__WEBPACK_IMPORTED_MODULE_1__["ElementRef"] }),
    tslib__WEBPACK_IMPORTED_MODULE_0__["__metadata"]("design:type", _angular_core__WEBPACK_IMPORTED_MODULE_1__["QueryList"])
], DisplayComponent.prototype, "performanceChartElementRefs", void 0);
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["ViewChildren"])('quality_chart', { read: _angular_core__WEBPACK_IMPORTED_MODULE_1__["ElementRef"] }),
    tslib__WEBPACK_IMPORTED_MODULE_0__["__metadata"]("design:type", _angular_core__WEBPACK_IMPORTED_MODULE_1__["QueryList"])
], DisplayComponent.prototype, "qualityChartElementRefs", void 0);
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["ViewChildren"])('oee_chart', { read: _angular_core__WEBPACK_IMPORTED_MODULE_1__["ElementRef"] }),
    tslib__WEBPACK_IMPORTED_MODULE_0__["__metadata"]("design:type", _angular_core__WEBPACK_IMPORTED_MODULE_1__["QueryList"])
], DisplayComponent.prototype, "oeeChartElementRefs", void 0);
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Input"])(),
    tslib__WEBPACK_IMPORTED_MODULE_0__["__metadata"]("design:type", Array)
], DisplayComponent.prototype, "results", void 0);
DisplayComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'mobility-tv-display',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./display.component.html */ "../../node_modules/raw-loader/dist/cjs.js!./src/app/display/display.component.html")).default,
        providers: [
            _services__WEBPACK_IMPORTED_MODULE_6__["ChartService"]
        ],
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./display.component.scss */ "./src/app/display/display.component.scss")).default]
    }),
    tslib__WEBPACK_IMPORTED_MODULE_0__["__metadata"]("design:paramtypes", [_services__WEBPACK_IMPORTED_MODULE_6__["EnvService"],
        _services__WEBPACK_IMPORTED_MODULE_6__["ChartService"]])
], DisplayComponent);



/***/ }),

/***/ "./src/app/pipes/minute-second.pipe.ts":
/*!*********************************************!*\
  !*** ./src/app/pipes/minute-second.pipe.ts ***!
  \*********************************************/
/*! exports provided: MinuteSecondsPipe */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MinuteSecondsPipe", function() { return MinuteSecondsPipe; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "../../node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "../../node_modules/@angular/core/fesm2015/core.js");


let MinuteSecondsPipe = class MinuteSecondsPipe {
    transform(value) {
        let hours;
        let restMinutes;
        const onedayMinutes = 1440; //24*60
        if (value < 60) {
            return `00:${value}:00`;
        }
        else if (value > 60 && value < onedayMinutes) {
            hours = Math.floor(value / 60).toString();
            if (hours.length < 2) {
                hours = '0' + hours;
            }
            restMinutes = (value % 60).toString();
            if (restMinutes.length < 2) {
                restMinutes = '0' + restMinutes;
            }
            return `${hours}:${restMinutes}:00`;
        }
    }
};
MinuteSecondsPipe = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Pipe"])({
        name: 'minuteSeconds'
    })
], MinuteSecondsPipe);



/***/ }),

/***/ "./src/app/pipes/second-hms.pipe.ts":
/*!******************************************!*\
  !*** ./src/app/pipes/second-hms.pipe.ts ***!
  \******************************************/
/*! exports provided: SecondsToHmsPipe */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SecondsToHmsPipe", function() { return SecondsToHmsPipe; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "../../node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "../../node_modules/@angular/core/fesm2015/core.js");


let SecondsToHmsPipe = class SecondsToHmsPipe {
    transform(value) {
        const d = Number(value);
        const h = Math.floor(d / 3600);
        const m = Math.floor(d % 3600 / 60);
        const s = Math.floor(d % 3600 % 60);
        const hDisplay = (h.toString().length < 2) ? '0' + h : h.toString();
        const mDisplay = (m.toString().length < 2) ? '0' + m : m.toString();
        const sDisplay = (s.toString().length < 2) ? '0' + s : s.toString();
        return hDisplay + ':' + mDisplay + ':' + sDisplay;
    }
};
SecondsToHmsPipe = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Pipe"])({
        name: 'secondsToHms'
    })
], SecondsToHmsPipe);



/***/ }),

/***/ "./src/app/services/chart/chart.service.ts":
/*!*************************************************!*\
  !*** ./src/app/services/chart/chart.service.ts ***!
  \*************************************************/
/*! exports provided: ChartService */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ChartService", function() { return ChartService; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "../../node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "../../node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var chart_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! chart.js */ "../../node_modules/chart.js/dist/Chart.js");
/* harmony import */ var chart_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(chart_js__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var chartjs_plugin_doughnutlabel__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! chartjs-plugin-doughnutlabel */ "../../node_modules/chartjs-plugin-doughnutlabel/dist/chartjs-plugin-doughnutlabel.js");
/* harmony import */ var chartjs_plugin_doughnutlabel__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(chartjs_plugin_doughnutlabel__WEBPACK_IMPORTED_MODULE_3__);



// import * as ChartDataLabels from 'chartjs-plugin-datalabels';

const DEFAULT_COLORS1 = ['#f08700', '#f49f0a', '#efca08', '#00a6a6', '#bbdef0'];
const DEFAULT_COLORS2 = ['#79aada', '#c8cfd6'];
let ChartService = class ChartService {
    constructor() {
        this.baseConfig = {
            plugins: [chartjs_plugin_doughnutlabel__WEBPACK_IMPORTED_MODULE_3__],
            type: 'doughnut',
            options: {
                responsive: true,
                legend: {
                    display: false,
                },
                title: {
                    display: false,
                },
                animation: {
                    animateScale: true,
                    animateRotate: true
                },
                plugins: {
                    doughnutlabel: {
                        labels: [
                            {
                                text: this.calculateChart,
                                font: {
                                    size: '40',
                                    weight: 'bold'
                                },
                                color: 'white'
                            }
                        ]
                    }
                }
            }
        };
    }
    buildEfisiensi(divId, values) {
        return new chart_js__WEBPACK_IMPORTED_MODULE_2__["Chart"](divId, {
            plugins: [chartjs_plugin_doughnutlabel__WEBPACK_IMPORTED_MODULE_3__],
            type: 'doughnut',
            data: {
                datasets: [{
                        data: [values[1], values[2]],
                        backgroundColor: DEFAULT_COLORS2,
                    }],
            },
            options: {
                responsive: true,
                maintainAspectRatio: false,
                tooltips: {
                    enabled: false
                },
                legend: {
                    display: false,
                },
                title: {
                    display: false,
                },
                animation: {
                    animateScale: true,
                    animateRotate: true
                },
                plugins: {
                    doughnutlabel: {
                        labels: [
                            {
                                text: values[0],
                                font: {
                                    size: '40',
                                    weight: 'bold'
                                },
                                color: 'white'
                            }
                        ]
                    }
                }
            }
        });
    }
    buildAvailability(divId, values) {
        return new chart_js__WEBPACK_IMPORTED_MODULE_2__["Chart"](divId, {
            plugins: [chartjs_plugin_doughnutlabel__WEBPACK_IMPORTED_MODULE_3__],
            type: 'doughnut',
            data: {
                datasets: [{
                        data: [values[1], values[2]],
                        backgroundColor: DEFAULT_COLORS2,
                    }],
            },
            options: {
                responsive: true,
                maintainAspectRatio: true,
                tooltips: {
                    enabled: false
                },
                legend: {
                    display: false,
                },
                title: {
                    display: false,
                },
                animation: {
                    animateScale: true,
                    animateRotate: true
                },
                plugins: {
                    doughnutlabel: {
                        labels: [
                            {
                                text: values[0],
                                font: {
                                    size: '40',
                                    weight: 'bold'
                                },
                                color: 'white'
                            }
                        ]
                    }
                }
            }
        });
    }
    buildPerformance(divId, values) {
        return new chart_js__WEBPACK_IMPORTED_MODULE_2__["Chart"](divId, {
            plugins: [chartjs_plugin_doughnutlabel__WEBPACK_IMPORTED_MODULE_3__],
            type: 'doughnut',
            data: {
                datasets: [{
                        data: [values[1], values[2]],
                        backgroundColor: DEFAULT_COLORS2,
                    }],
            },
            options: {
                responsive: true,
                maintainAspectRatio: true,
                tooltips: {
                    enabled: false
                },
                legend: {
                    display: false,
                },
                title: {
                    display: false,
                },
                animation: {
                    animateScale: true,
                    animateRotate: true
                },
                plugins: {
                    doughnutlabel: {
                        labels: [
                            {
                                text: values[0],
                                font: {
                                    size: '40',
                                    weight: 'bold'
                                },
                                color: 'white'
                            }
                        ]
                    }
                }
            }
        });
    }
    buildQuality(divId, values) {
        return new chart_js__WEBPACK_IMPORTED_MODULE_2__["Chart"](divId, {
            plugins: [chartjs_plugin_doughnutlabel__WEBPACK_IMPORTED_MODULE_3__],
            type: 'doughnut',
            data: {
                datasets: [{
                        data: [values[1], values[2]],
                        backgroundColor: DEFAULT_COLORS2,
                    }],
            },
            options: {
                responsive: true,
                maintainAspectRatio: true,
                tooltips: {
                    enabled: false
                },
                legend: {
                    display: false,
                },
                title: {
                    display: false,
                },
                animation: {
                    animateScale: true,
                    animateRotate: true
                },
                plugins: {
                    doughnutlabel: {
                        labels: [
                            {
                                text: values[0],
                                font: {
                                    size: '40',
                                    weight: 'bold'
                                },
                                color: 'white'
                            }
                        ]
                    }
                }
            }
        });
    }
    buildOEE(divId, values) {
        return new chart_js__WEBPACK_IMPORTED_MODULE_2__["Chart"](divId, {
            plugins: [chartjs_plugin_doughnutlabel__WEBPACK_IMPORTED_MODULE_3__],
            type: 'doughnut',
            data: {
                datasets: [{
                        data: [values[1], values[2]],
                        backgroundColor: DEFAULT_COLORS2,
                    }],
            },
            options: {
                responsive: true,
                maintainAspectRatio: false,
                tooltips: {
                    enabled: false
                },
                legend: {
                    display: false,
                },
                title: {
                    display: false,
                },
                animation: {
                    animateScale: true,
                    animateRotate: true
                },
                plugins: {
                    doughnutlabel: {
                        labels: [
                            {
                                text: values[0],
                                font: {
                                    size: '40',
                                    weight: 'bold'
                                },
                                color: 'white'
                            }
                        ]
                    }
                }
            }
        });
    }
    calculateChart(chart) {
        const sum = chart.config.data.datasets[0].data.reduce((a, b) => a + b, 0);
        return sum;
    }
};
ChartService = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Injectable"])({
        providedIn: 'root'
    }),
    tslib__WEBPACK_IMPORTED_MODULE_0__["__metadata"]("design:paramtypes", [])
], ChartService);



/***/ }),

/***/ "./src/app/services/data/data.service.ts":
/*!***********************************************!*\
  !*** ./src/app/services/data/data.service.ts ***!
  \***********************************************/
/*! exports provided: DataService */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DataService", function() { return DataService; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "../../node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "../../node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_common_http__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/common/http */ "../../node_modules/@angular/common/fesm2015/http.js");
/* harmony import */ var _env_env_service__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../env/env.service */ "./src/app/services/env/env.service.ts");




const POLLING_INTERVAL = 6000; // in milliseconds
let DataService = class DataService {
    constructor(httpClient, env) {
        this.httpClient = httpClient;
        this.env = env;
        //
    }
    getData(id) {
        if (id) {
            const url = this.env.apiUrl + '/mobility_order_monitor?display_group=' + id;
            return this.httpClient.get(url);
        }
        return null;
    }
    getJSON(id) {
        return this.httpClient.get("./assets/data/dummy.json");
    }
};
DataService.ctorParameters = () => [
    { type: _angular_common_http__WEBPACK_IMPORTED_MODULE_2__["HttpClient"] },
    { type: _env_env_service__WEBPACK_IMPORTED_MODULE_3__["EnvService"] }
];
DataService = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Injectable"])({
        providedIn: 'root'
    }),
    tslib__WEBPACK_IMPORTED_MODULE_0__["__metadata"]("design:paramtypes", [_angular_common_http__WEBPACK_IMPORTED_MODULE_2__["HttpClient"],
        _env_env_service__WEBPACK_IMPORTED_MODULE_3__["EnvService"]])
], DataService);



/***/ }),

/***/ "./src/app/services/env/env.service.provider.ts":
/*!******************************************************!*\
  !*** ./src/app/services/env/env.service.provider.ts ***!
  \******************************************************/
/*! exports provided: EnvServiceFactory, EnvServiceProvider */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "EnvServiceFactory", function() { return EnvServiceFactory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "EnvServiceProvider", function() { return EnvServiceProvider; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "../../node_modules/tslib/tslib.es6.js");
/* harmony import */ var _env_service__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./env.service */ "./src/app/services/env/env.service.ts");


const EnvServiceFactory = () => {
    // Create env
    const env = new _env_service__WEBPACK_IMPORTED_MODULE_1__["EnvService"]();
    // Read environment variables from browser window
    const browserWindow = window || {};
    // tslint:disable-next-line:no-string-literal
    const browserWindowEnv = browserWindow['__env'] || {};
    // Assign environment variables from browser window to env
    // In the current implementation, properties from env.js overwrite defaults from the EnvService.
    // If needed, a deep merge can be performed here to merge properties instead of overwriting them.
    for (const key in browserWindowEnv) {
        if (browserWindowEnv.hasOwnProperty(key)) {
            // tslint:disable-next-line:no-string-literal
            env[key] = window['__env'][key];
        }
    }
    return env;
};
const EnvServiceProvider = {
    provide: _env_service__WEBPACK_IMPORTED_MODULE_1__["EnvService"],
    useFactory: EnvServiceFactory,
    deps: [],
};


/***/ }),

/***/ "./src/app/services/env/env.service.ts":
/*!*********************************************!*\
  !*** ./src/app/services/env/env.service.ts ***!
  \*********************************************/
/*! exports provided: EnvService */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "EnvService", function() { return EnvService; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "../../node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "../../node_modules/@angular/core/fesm2015/core.js");


let EnvService = class EnvService {
    constructor() {
        // API url
        // public apiUrl = 'http://localhost:5059/api/v1';
        this.apiUrl = 'https://staging-agp-api.nitoza.com/mobility_dashboard/api/v1';
        // Socket url
        // public socketUrl = 'http://localhost:5005';
        this.socketUrl = 'https://staging-agp-tv-socket.nitoza.com';
        // Polling interval (default 5 minutes)
        this.interval = 5000;
        // Whether or not to enable debug mode
        this.enableDebug = true;
    }
};
EnvService = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Injectable"])({
        providedIn: 'root'
    }),
    tslib__WEBPACK_IMPORTED_MODULE_0__["__metadata"]("design:paramtypes", [])
], EnvService);



/***/ }),

/***/ "./src/app/services/index.ts":
/*!***********************************!*\
  !*** ./src/app/services/index.ts ***!
  \***********************************/
/*! exports provided: EnvService, EnvServiceFactory, EnvServiceProvider, ChartService, DataService */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "../../node_modules/tslib/tslib.es6.js");
/* harmony import */ var _env_env_service__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./env/env.service */ "./src/app/services/env/env.service.ts");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "EnvService", function() { return _env_env_service__WEBPACK_IMPORTED_MODULE_1__["EnvService"]; });

/* harmony import */ var _env_env_service_provider__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./env/env.service.provider */ "./src/app/services/env/env.service.provider.ts");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "EnvServiceFactory", function() { return _env_env_service_provider__WEBPACK_IMPORTED_MODULE_2__["EnvServiceFactory"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "EnvServiceProvider", function() { return _env_env_service_provider__WEBPACK_IMPORTED_MODULE_2__["EnvServiceProvider"]; });

/* harmony import */ var _chart_chart_service__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./chart/chart.service */ "./src/app/services/chart/chart.service.ts");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ChartService", function() { return _chart_chart_service__WEBPACK_IMPORTED_MODULE_3__["ChartService"]; });

/* harmony import */ var _data_data_service__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./data/data.service */ "./src/app/services/data/data.service.ts");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "DataService", function() { return _data_data_service__WEBPACK_IMPORTED_MODULE_4__["DataService"]; });








/***/ }),

/***/ "./src/environments/environment.ts":
/*!*****************************************!*\
  !*** ./src/environments/environment.ts ***!
  \*****************************************/
/*! exports provided: environment */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "environment", function() { return environment; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "../../node_modules/tslib/tslib.es6.js");
// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

const environment = {
    production: false
};
/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.


/***/ }),

/***/ "./src/main.ts":
/*!*********************!*\
  !*** ./src/main.ts ***!
  \*********************/
/*! no exports provided */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "../../node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "../../node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_platform_browser_dynamic__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/platform-browser-dynamic */ "../../node_modules/@angular/platform-browser-dynamic/fesm2015/platform-browser-dynamic.js");
/* harmony import */ var _app_app_module__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./app/app.module */ "./src/app/app.module.ts");
/* harmony import */ var _environments_environment__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./environments/environment */ "./src/environments/environment.ts");





if (_environments_environment__WEBPACK_IMPORTED_MODULE_4__["environment"].production) {
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["enableProdMode"])();
}
Object(_angular_platform_browser_dynamic__WEBPACK_IMPORTED_MODULE_2__["platformBrowserDynamic"])()
    .bootstrapModule(_app_app_module__WEBPACK_IMPORTED_MODULE_3__["AppModule"])
    .catch(err => console.error(err));


/***/ }),

/***/ 0:
/*!***************************!*\
  !*** multi ./src/main.ts ***!
  \***************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(/*! /home/administrator/app/mobility-tv-v2/apps/mobility-tv/src/main.ts */"./src/main.ts");


/***/ })

},[[0,"runtime","vendor"]]]);
//# sourceMappingURL=main-es2015.js.map